/**
 * Enumeration of all modal types available in the application.
 * Used to identify and manage different modal dialogs throughout the app.
 */
enum Modals {
  ACTIVATE_GENERIC,
  ACTIVATE_ZAPPER,
  ANONYMOUS_GENERIC,
  ANONYMOUS_ZAPPER,
  CHANNEL_NOT_ALLOWED,
  CLOSE_PLAYER,
  DEADMAN_ZAPPER,
  EXIT_APP,
  GENERIC_ERROR,
  LOGOUT,
  PAUSE_AD,
  PARENTAL_PIN_GENERIC,
  PARENTAL_PIN_ZAPPER,
  PLAYER_ERROR,
  PLAYER_LANGUAGE,
  RECORDING_DELETE,
  RECORDING_REQUEST,
  SUBSCRIBE_ADDON,
  UPGRADE_ADDON,
  UPGRADE_PLAN,
  ZOOM,
  UPGRADE_RECORD_PLAN,
}

export default Modals;
